import { RepliersListing } from '../../types/repliers/RepliersListing';
import { RepliersListingLastStatus } from '../../types/repliers/RepliersListingLastStatus';
import { RepliersListingStatus } from '../../types/repliers/RepliersListingStatus';

export default function getLastStatusFromRepliersListing(
  repliersListing: RepliersListing,
): null | RepliersListingLastStatus {
  if (
    repliersListing.lastStatus ===
      RepliersListingLastStatus.SoldConditionally &&
    repliersListing.status === RepliersListingStatus.Inactive
  ) {
    return RepliersListingLastStatus.Sold;
  }

  return repliersListing.lastStatus;
}
